(ns teamoesterreich.style.toe-material-style
  (:require [reagent.core :as r]
            [reagent-material-ui.colors :as mui-colors]
            [reagent-material-ui.styles :as styles]
            ))



(def toe-theme
  {:palette    {:primary   {:light        "#e55432"
                            :main         "#e10032"
                            :dark         "#760000"
                            :contrastText "#fff"}
                :secondary {:light        "#5e52e2"
                            :main         "#1628af"
                            :dark         "#00037e"
                            :contrastText "#ffffff"}}
   :components {:menu-item                                  ;;not working
                {:styleOverrides {
                                  :root {}
                                  }}}
   :overrides  {
                ;// Applied to the <ul> element
                :MuiMenu     {
                              :list {
                                     ;:backgroundColor "#cccccc"
                                     }
                              }
                ;// Applied to the <li> elements
                :MuiMenuItem {
                              :root {
                                     :backgroundColor "#c1d3e3"
                                     :&.Mui-selected  {:backgroundColor    "green"
                                                       :&.Mui-focusVisible {:background "orange"}
                                                       }
                                     }

                              }
                }})



(def toe-mui-theme
  (styles/create-mui-theme toe-theme))

(def modal {:position        "absolute"
            :top             50
            :left            50
            :padding         10
            :backgroundColor (:white mui-colors/common)
            :border-size     2
            :border-color    ""
            :border-radius   4
            })


(defn toe-styles [{:keys [spacing] :as theme}]
  {:button     {:margin (spacing 1)}
   :modal      modal
   :text-field {:width        200
                :margin-left  (spacing 1)
                :margin-right (spacing 1)}})



(def with-toe-styles (styles/with-styles toe-styles))